import { Tag } from '../tag'
import _ from 'lodash'

export default {
  name: 'KRdTag',
  functional: true,
  render(createElement, context) {
    const isClearable = 'clearable' in context.props && context.props.clearable !== false

    const extendData = {
      class: {
        'km-rd-tag': true,
        'km-rd-tag--clearable': isClearable,
      },
    }
    // 处理JSX写法的静态class
    if (typeof context.data.class === 'string' && context.data.class) {
      extendData.staticClass = context.data.class + ' ' + context.data.staticClass
    }

    const renderData = _.merge({}, context.data, extendData)
    return <Tag {...renderData}>
      {context.children}
    </Tag>
  },
}
